const RE_ABSOLUTE_URL = /^(https?:)?\/\//;

/**
 * Resolve `url` to an absolute URL.
 *
 * It prepends `baseUrl` or falls back to `location.origin` otherwise.
 */
export function resolveUrl(url: string, baseUrl: string) {
  if (RE_ABSOLUTE_URL.exec(url)) return url;

  const prefix = baseUrl || location.origin;
  const sep = url[0] === '/' ? '' : '/';

  return `${prefix}${sep}${url}`;
}
